import { render, staticRenderFns } from "./ModalExcludedCommodities.vue?vue&type=template&id=2a04db5c&scoped=true"
import script from "./ModalExcludedCommodities.vue?vue&type=script&lang=js"
export * from "./ModalExcludedCommodities.vue?vue&type=script&lang=js"
import style0 from "./ModalExcludedCommodities.vue?vue&type=style&index=0&id=2a04db5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04db5c",
  null
  
)

export default component.exports